import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Box,
  Typography,
  Alert,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { fetchIndustryData, uploadIndustryExcel, setSuccess, setError } from '../../Redux/IndustryDataSlice';
import './UploadIndustryLearningData.css';
import SampleExcel from '../../data/IndustryTraining_NewTemplate.xlsx';
import mailData from './../../data/mailData';

const UploadIndustryLearningData = () => {
  const dispatch = useDispatch();
  const { data, fyTarget, isLoading, error, success } = useSelector(state => state.industryData);

  const [file, setFile] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [showUser, setShowUser] = useState(false);


  const handleFileChange = (e) => setFile(e.target.files[0]);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);


  const { instance } = useMsal();
  const usersList = [
    "arpita.m.singh",
    "varsha.a.tyagi",
    "h.srinivasan",
    "aluru.akash",
    "aayushi.bharti",
    "uma.rani.battu",
    "ankur.e.mishra",
    "reshmi.haridas.m",
    "jeevadharani.ramanan",
    "sharda.mankare",
    "amrita.verma",
    "potnuru.sandeep",
    "shubham.i.tyagi",
    "lakshay.c.gupta"
  ];

  const activeAccount = instance.getActiveAccount();
  let activeUsername = '';
  if (activeAccount) activeUsername = activeAccount.username;

  useEffect(() => {
    if (activeAccount && usersList.includes(activeAccount.idTokenClaims.enterpriseID)) {
      setShowUser(true);
    }
  }, [instance]);

  useEffect(() => {
    dispatch(fetchIndustryData());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setOpenModal(false);
        dispatch(setSuccess(null));
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [success, dispatch]);
  const handleUpload = async () => {
    if (!file) {
      dispatch(setError('Please select a file before uploading.'));
      return;
    }

    await dispatch(uploadIndustryExcel(file));
  };

  const getFiscalYear = () => {
    const date = new Date(fyTarget.updated_at || new Date());
    const month = date.getMonth();
    const year = date.getFullYear();
    return month >= 8 ? `FY${(year + 1).toString().slice(2)}` : `FY${year.toString().slice(2)}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <div>
      {showUser && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
          <Button
            variant="contained"
            onClick={handleOpen}
            sx={{
              backgroundColor: '#7500c0',
              '&:hover': { backgroundColor: '#6a1b9a' },
              textTransform: "none",
              borderRadius: "20px",
              fontWeight: "bold"
            }}
          >
            Admin
          </Button>
        </div>
      )}

      <Modal open={openModal} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: "60%",
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            textAlign: 'center',
            height: '500px',
            overflowY: 'auto'
          }}
          className="modal-box-container"
        >
          <IconButton
            onClick={handleClose}
            sx={{ position: 'absolute', top: 8, right: 8, color: 'grey.700' }}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" mb={2}>Upload Industry Training Excel</Typography>
          <input type="file" onChange={handleFileChange} style={{ marginBottom: '15px' }} />

          {success && (
            <Alert
              severity="success"
              onClose={() => dispatch(setSuccess(null))}
              sx={{ mb: 2 }}
            >
              {success}
            </Alert>
          )}

          {error && (
            <Alert
              severity="error"
              onClose={() => dispatch(setError(null))}
              sx={{ mb: 2 }}
            >
              {error}
            </Alert>
          )}

          <Button
            variant="contained"
            color="secondary"
            onClick={handleUpload}
            sx={{
              backgroundColor: '#7500c0',
              '&:hover': { backgroundColor: '#6a1b9a' },
              textTransform: "none",
              fontWeight: "bold"
            }}
          >
            Upload
          </Button>

          <div className="instructions-container">
            <span className="key-statistics-upload-instructions">Instructions</span>
            <div>
              <ol className="Instructions-List">
                <li>
                  To publish the data by uploading the template, in case if there is any doubt or clarification please refer the <a href="images/AdminPage/Job-Aid-for-Industry-Training-Completion-Data.docx" className="key-statistics-sample-file">job aid</a>.
                </li>
                <li>
                  The data needs to be uploaded in a given template format. Any change in the template will lead
                  to upload failure or error messages.
                  <a href={SampleExcel} target="_blank" className="key-statistics-sample-file"
                    rel="noreferrer"> Click here </a>
                  to download the data template. <strong>Do not modify</strong> the column name and order of the column in the template.
                </li>
                <li>
                  For a successful upload of new Industry Training data every time use new excel file, avoid making changes to the older one.
                </li>
                <li>
                  Please avoid uploading or updating the data frequently to avoid any issues. In case if any corrections
                  required and its unavoidable please re-upload the excel file again and publish the data.
                </li>
                <li>
                  In case if you need to add or remove access for admin page please contact <a href="mailto:ATCI.LKM.LIS.PORTALDEVELOPMENT" className="lkm-calendar-sample-file">{mailData.uploadDataComponent.atci_lkm_lis_portal_developmemnt}@{mailData.domain}</a>
                </li>
                <li>
                  Whenever there is a change in the Industry Training page, admins will be notified via mail
                </li>
                <li>
                  The members who have admin access :
                  <table className="table_Names">
                    <tr>
                      <td>h.srinivasan</td>
                      <td>varsha.a.tyagi</td>
                      <td>jeevadharani.ramanan</td>
                      <td>arpita.m.singh</td>
                      <td>aluru.akash</td>
                      <td>amrita.verma</td>
                    </tr>
                    <tr>
                      <td>uma.rani.battu</td>
                      <td>reshmi.haridas.m</td>
                      <td>ankur.e.mishra</td>
                      <td>aayushi.bharti</td>
                      <td>sharda.mankare</td>
                      
                    </tr>
                  </table>
                </li>
              </ol>
              <br></br>
            </div>
          </div>
        </Box>
      </Modal>

      {showUser && (
        <>
          <h2 style={{ backgroundColor: '#e9c9f1', padding: '10px', textAlign: "center", border: "1px solid", widt: '100%' }}>
            Industry Training Completion data - {getFiscalYear()}
          </h2>
          <h4 style={{ backgroundColor: '#fdf6b2', padding: '5px', textAlign: "center", borderRight: "1px solid", borderLeft: "1px solid", width: '100%' }}>
            Data updated - {formatDate(fyTarget.updated_at)}
            {/* Data updated - 8th May 2025 */}
          </h4>

          <table border="1" cellPadding="5" style={{ borderCollapse: 'collapse', width: '100%' }} className="industry_table" >
            <thead className="industry_table_thead">
              <tr>
                <th style={{ backgroundColor: "#A6C9EC" }}>Region</th>
                <th style={{ backgroundColor: "#A6C9EC" }}>Total HC</th>
                <th style={{ backgroundColor: "#A6C9EC" }}>Target</th>
                <th style={{ backgroundColor: "#E2E2FF" }}>FY25 Unique Learners</th>
                <th style={{ backgroundColor: "#E2E2FF" }}>FY25 % Completion</th>
                <th style={{ backgroundColor: "#E2E2FF" }}>FY26 Unique Learners</th>
                <th style={{ backgroundColor: "#E2E2FF" }}>FY26 % Completion</th>
                <th style={{ backgroundColor: "#F2CEEF" }}>Foundation Learners</th>
                <th style={{ backgroundColor: "#F2CEEF" }}>Foundation % Learners</th>
                <th style={{ backgroundColor: "#FBE2D5" }}>Focused Learners</th>
                <th style={{ backgroundColor: "#FBE2D5" }}>Focused % Learners</th>
                <th style={{ backgroundColor: "#CAEDFB" }}>Industry Day Learners</th>
                <th style={{ backgroundColor: "#CAEDFB" }}>Industry Day % Learners</th>
                <th style={{ backgroundColor: "#DAF2D0" }}>Reinvention Academy Learners</th>
                <th style={{ backgroundColor: "#DAF2D0" }}>Reinvention Academy % Learners</th>
                <th className="fy_target_th">{getFiscalYear()} Target</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={16} style={{ textAlign: "center", padding: "20px", fontStyle: "italic" }}>
                    No data to display.
                  </td>
                </tr>
              ) : (
                data.map((row, index) => {
                  if (!row) return null;
                  const isFirstRow = index === 0;
                  const isTotal = row.region?.toLowerCase?.() === "total";

                  return (
                    <tr
                      className="industry_table_td"
                      key={index}
                      style={{
                        backgroundColor: isTotal ? "#DAF2D0" : "white",
                        fontWeight: isTotal ? "bold" : "normal",
                      }}
                    >
                      <td>{row.region}</td>
                      <td>{row.total_hc}</td>
                      <td>{row.target}</td>
                      <td>{row.fy25_unique_learners}</td>
                      <td>{row.fy25_percent_completion}</td>
                      <td>{row.fy26_unique_learners}</td>
                      <td>{row.fy26_percent_completion}</td>
                      <td>{row.foundation_learners}</td>
                      <td>{row.percent_foundation}</td>
                      <td>{row.focused_learners}</td>
                      <td>{row.percent_focused}</td>
                      <td>{row.industry_day_learners}</td>
                      <td>{row.percent_industry_day}</td>
                      <td>{row.reinvention_academy_learners}</td>
                      <td>{row.percent_reinvention_academy}</td>
                      {isFirstRow && (
                        <td
                          rowSpan={data.length}
                          style={{
                            backgroundColor: "#DAF2D0",
                            fontSize: "12px",
                            fontWeight: "bold",
                            textAlign: "center",
                            verticalAlign: "bottom",
                            whiteSpace: "pre-line",
                          }}
                        >
                          {fyTarget?.value}
                        </td>
                      )}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </>
      )}

    </div>
  );
};

export default UploadIndustryLearningData;
